import React from 'react'
import img1 from './images/assign-leads.webp';
import img2 from './images/bot-power.webp';
import img3 from './images/whatsapp-chat.webp';
import img4 from './images/ai-power.webp';

const Wp_Features = () => {
    const features = [
        {
            title: "AI-Powered Conversations",
            desc:
                "Answer like a human, not a script. The bot understands intent and context, remembers past chats, and completes tasks—queries, bookings, and payments—right inside WhatsApp. Complex cases hand off to a human with full context.",
            cta: "See how it works",
            img: img4
        },
        {
            title: "Replace repetitive queries with 24/7 bot power",
            desc:
                "Let the bot instantly handle FAQs like pricing, orders, refunds, and appointments—day or night. It fetches answers, runs workflows (tickets, updates, payments), and involves a human only when needed.",
            cta: "Automate FAQs",
            img: img2
        },
        {
            title: "Sell directly in WhatsApp chats",
            desc:
                "Turn conversations into checkout. Let customers browse, add to cart, apply coupons, and pay via UPI/cards/wallets—without leaving WhatsApp. Auto-send invoices and order updates to reduce drop-offs.",
            cta: "Start selling",
            img: img3
        },
        {
            title: "Assign leads like a pro — no micromanaging",
            desc:
                "New inquiries are auto-captured and routed to the right rep by rules you set—region, product, workload, or SLA. Round-robin or skill-based assignment, with clear ownership and reminders to stop leakage.",
            cta: "Streamline routing",
            img: img1
        }
    ];

    return (
        <section className="py-4 position-relative" 
        style={{ 
            overflow: 'hidden',
            }}
            >
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative"
                style={{
                    maxWidth: '74%',
                    zIndex: 1,
                    marginTop: 80
                }}
            >
                {/* Heading */}
                <div>
                    <h2
                        style={{
                            fontSize: "2.5rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        Key features and functionalities of
                        <br />
                        <span style={{ color: "#1DB954" }}>WhatsApp Chatbot</span> Platform
                    </h2>
                </div>

                {/* Features alternating */}
                <div style={{ marginTop: 50 }}>
                    {features.map((f, i) => (
                        <div className={`wp-row ${i % 2 !== 0 ? 'reverse' : ''}`} key={i}>
                            <div className="wp-img">
                                <img src={f.img} alt={f.title} />
                            </div>
                            <div className="wp-content">
                                <h3 className="wp-title">{f.title}</h3>
                                <p className="wp-desc">{f.desc}</p>
                                <button className="wp-btn" type="button">{f.cta}</button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <style>{`
        .wp-row{
          display:flex; 
          align-items:center; 
          justify-content:space-between; 
          gap:48px;
          margin-bottom:80px;
        }
        .wp-row.reverse{
          flex-direction:row-reverse;
        }
        .wp-img{ 
           flex:1; 
           text-align:center; 
        }
        .wp-img img{ 
           width:100%; 
           max-width:520px; 
           border-radius:14px; 
        }
        .wp-content{ flex:1; }
        .wp-title{
          font-size:1.9rem; 
          font-weight:600; 
          font-family:Lato;
          color: #242121ff;
          line-height:1.2; 
        }
        .wp-desc{
          font-size:1.2rem; 
          font-family:Lato;
          font-weight: 400;
          line-height:1.2; 
          color: #646363ff; 
          margin:0 0 16px 0;
        }
        .wp-btn{
          display:inline-block; 
          padding:10px 16px; 
          border-radius:10px;
          background: #1d78b9ff; 
          color:#fff; 
          font-weight:600; 
          font-family:Inter,system-ui;
          border:none; 
          cursor:pointer; 
          transition:transform .12s ease, 
          box-shadow .12s ease;
        //   box-shadow:0 6px 18px rgba(29, 102, 185, 0.25);
        }
        .wp-btn:active{ transform:translateY(1px); }
        @media (max-width: 900px){
          .wp-row, 
          .wp-row.reverse{ flex-direction:column; 
          text-align:left; 
          gap:24px; 
          margin-bottom:56px; 
        }
          .wp-img img{ max-width:100%; }
        }
      `}</style>
        </section>
    )
}

export default Wp_Features
